/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadConfiguration {
    getFixupPrototypeFunction() { return WorkloadConfiguration.fixupPrototype; }

    static newInstance(model: Partial<WorkloadConfiguration>): WorkloadConfiguration {
        let obj = Object.assign(new WorkloadConfiguration(), model);
        WorkloadConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadConfiguration>): WorkloadConfiguration {
        if (!model) return null;
        return WorkloadConfiguration.newInstance(<WorkloadConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadConfiguration) {
        if (!obj) return;

        models.WorkloadConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadConfiguration): boolean {
        Object.setPrototypeOf(obj, WorkloadConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tiers) {
            for (let val of this.tiers) {
                models.WorkloadTierConfiguration.fixupPrototype(val);
            }
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Tiers composing the workload
     */
    tiers: Array<models.WorkloadTierConfiguration>;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

}
